import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RepeatOrderService } from '@app/shared/services/repeat-order.service';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-repeated-order-list',
  templateUrl: './repeated-order-list.component.html',
  styleUrls: ['./repeated-order-list.component.css']
})
export class RepeatedOrderListComponent implements OnInit {

  repeatedOrderList: any[] = [];
  displayedUsers: any[] = []; // This is used to display the filtered and paginated list
  itemsPerPage: number = 15;
  currentPage: number = 1;
  totalItems: number;
  sortDirection: string = 'asc';
  sortColumn: string = ''; // To keep track of the currently sorted column
  searchText: string = ''; // Search text for filtering
  mathLib: any = Math;
  

  constructor(
    private repeated: RepeatOrderService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.getAllRepeatedList();
  }

  getAllRepeatedList() {
    this.repeated.getAllRepeatOrder().subscribe(
      (res: any) => {
        this.repeatedOrderList = res.reverse();
        this.totalItems = this.repeatedOrderList.length;
        this.updateDisplayedUsers();
        this.cdr.detectChanges();
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

//  // Method to handle edit button click
// edit(orderId: string) {
//   this.router.navigate(['/edit', orderId]);  // Navigate to the edit route and pass the order ID
// }


  onSortColumn(column: string) {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    this.sortColumn = column; // This is a string that holds the name of the column to sort by
    this.repeatedOrderList.sort((a, b) => {
      const valueA = a[column];
      const valueB = b[column];
      if (valueA < valueB) {
        return this.sortDirection === 'asc' ? -1 : 1;
      }
      if (valueA > valueB) {
        return this.sortDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });
    this.updateDisplayedUsers();
  }

  deleteRepeatOrder(itemId: string) {
    if (confirm('Are you sure you want to delete this Repeated order?')) {
      this.repeated.deleteRepeatOrder(itemId).subscribe(() => {
        this.repeatedOrderList = this.repeatedOrderList.filter(repeatedorder => repeatedorder._id !== itemId);
        this.totalItems = this.repeatedOrderList.length;
        this.updateDisplayedUsers();
        this.cdr.detectChanges();
      }, error => {
        console.error('Error while deleting this entry:', error);
      });
    }
  }

  updateDisplayedUsers() {
    const filteredUsers = this.filterUsers(this.repeatedOrderList);
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.displayedUsers = filteredUsers.slice(startIndex, endIndex);
    this.totalItems = filteredUsers.length;
  }

  // getPages(): number[] {
  //   const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
  //   return Array.from({ length: totalPages }, (_, index) => index + 1);
  // }
  getPages(): number[] {
    const totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
    const maxPagesToShow = 1; // Number of pages to show around the current page
  
    // Start and end page number for the window
    let startPage = Math.max(1, this.currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(totalPages, this.currentPage + Math.floor(maxPagesToShow / 2));
  
    // Adjust the range to ensure it's at least showing `maxPagesToShow` pages if possible
    if (endPage - startPage + 1 < maxPagesToShow) {
      if (this.currentPage < Math.floor(maxPagesToShow / 2)) {
        endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);
      } else {
        startPage = Math.max(1, endPage - maxPagesToShow + 1);
      }
    }
  
    return Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index);
  }
  

  // onPageChange(page: number) {
  //   if (page >= 1 && page <= Math.ceil(this.totalItems / this.itemsPerPage)) {
  //     this.currentPage = page;
  //     this.updateDisplayedUsers();
  //   }
  // }

  onPageChange(page: number) {
  if (page >= 1 && page <= Math.ceil(this.totalItems / this.itemsPerPage)) {
    this.currentPage = page;
    this.updateDisplayedUsers();
  }
}

  onSearch() {
    this.currentPage = 1;
    this.updateDisplayedUsers();
  }

  filterUsers(users: any[]): any[] {
    const searchTerm = this.searchText.toLowerCase();
    return users.filter(user =>
      user.clientName.toLowerCase().includes(searchTerm) ||
      user.ticketno.toLowerCase().includes(searchTerm) ||
      user.jobName.toLowerCase().includes(searchTerm)
    );
  }

  previewOrder(orderId: string) {
    this.repeated.getRepeatOrderById(orderId).subscribe((order: any) => {
        console.log(order);
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.width;
        const topMargin = 2;
        const sideMargin = 10;
        doc.setFont('helvetica');
        const adjustedTop = topMargin + 8;
        const adjustedLeft = sideMargin + 10;
        doc.setFont('helvetica', 'bold');
        const ticketText = 'LEXIPACK GHANA LIMITED';
        const companyName = order.clientName || '';
        const companyJob = `${order.jobName || ''} (${order.jobType || ''})`;
        const textWidth = doc.getTextWidth(ticketText);
        const textX = (pageWidth - textWidth) / 2;
        doc.setFontSize(13);
        doc.text(ticketText, textX, adjustedTop + 2);
        doc.text(companyName, adjustedLeft, adjustedTop + 10);
        doc.text(companyJob, adjustedLeft, adjustedTop + 16);
        doc.line(sideMargin, adjustedTop + 18, pageWidth - sideMargin, adjustedTop + 18);
        doc.setFontSize(11);
        doc.setFont('helvetica', 'normal');

        // Render client and job details
        const PoNo = `Po No: ${order.poNo}`;
        doc.text(PoNo, adjustedLeft - 8, adjustedTop + 23);

        // Handle the created date safely
        const originalDate = new Date(order.created);
        if (!isNaN(originalDate.getTime())) {
            const formattedDate = originalDate.toISOString().split('T')[0];
            const formattedDateString = `Date: ${formattedDate}`;
            doc.text(formattedDateString, adjustedLeft + 60, adjustedTop + 23);
        } else {
            console.error('Invalid creation date:', order.created);
            doc.text('Date: Invalid date', adjustedLeft + 60, adjustedTop + 23);
        }

        // Get current time
        const currentDate = new Date();
        const currentTime = currentDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        const time = `Time: ${currentTime}`;
        doc.text(time, adjustedLeft + 95, adjustedTop + 23);

        // Set font style to bold
        doc.setFontSize(13); // Change the number to your desired font size

        doc.setFont('helvetica', 'bold');
        const Challan_No = `Ticket No: ${order.ticketno}`;
        doc.text(Challan_No, adjustedLeft + 140, adjustedTop + 10);

        // Client details
        doc.setFontSize(11); // Change the number to your desired font size

        const clientDetails = `Ref No: ${order.refNo}`;
        doc.setFont('helvetica', 'bold');
        doc.text(clientDetails, adjustedLeft - 8, adjustedTop + 32);

        // More details...
        const Serial = `FolderNo: ${order.jssfolderno}`;
        doc.text(Serial, adjustedLeft + 60, adjustedTop + 32);
        doc.setFont('helvetica', 'normal');
        const Barcode = `Barcode: ${order.barcode}`;
        doc.text(Barcode, adjustedLeft + 140, adjustedTop + 32);
        const Total_CMT = `JobType: ${order.jobType}`;
        doc.text(Total_CMT, adjustedLeft - 8, adjustedTop + 40);

        // Handle the delivery date safely
        const ddDate = new Date(order.ddDate);
        if (!isNaN(ddDate.getTime())) {
            const formattedddDate = ddDate.toISOString().split('T')[0];
            const formattedDDDateString = `Delivery Date: ${formattedddDate}`;
            doc.text(formattedDDDateString, adjustedLeft + 140, adjustedTop + 40);
        } else {
            console.error('Invalid delivery date:', order.ddDate);
            doc.text('Delivery Date: Invalid date', adjustedLeft + 140, adjustedTop + 40);
        }

        const status = `Status: ${order.status}`;
        doc.text(status, adjustedLeft + 140, adjustedTop + 45);

        // Quantity details
        const gradeQtyDetails = `Quantity:`;
        doc.text(gradeQtyDetails, adjustedLeft - 8, adjustedTop + 50);
        // const Qty = `Kgs: ${order.orderKgs}`;
        const Qty = `Kgs: ${parseFloat(order.orderKgs || 0).toFixed(2)}`;
        doc.text(Qty, adjustedLeft + 20, adjustedTop + 50);
        // const TM_No = `PCs: ${order.pouch || order.orderPcs}`;
        const TM_No = `PCs: ${parseFloat(order.pouch || order.orderPcs).toFixed(2)}`;
        doc.text(TM_No, adjustedLeft + 20, adjustedTop + 55);

        const Time_In = `Remarks: ${order.repeatedRemarks || order.remark }`;
       const wrappedText = doc.splitTextToSize(Time_In, 100); // 100 is the max width, adjust as needed
       doc.text(wrappedText, adjustedLeft + 70, adjustedTop + 52);

        const processes = [
          'Process 1', 'Process 2', 'Process 3', 'Process 4', 'Process 5', 'Process 6'
      ];
        // Material Allocation section
        doc.line(sideMargin, adjustedTop + 59, pageWidth - sideMargin, adjustedTop + 59);
        doc.text(`RAW MATERIAL ALLOCATION`, adjustedLeft - 8, adjustedTop + 65);
        doc.text(`Processes`, adjustedLeft - 5, adjustedTop + 70);
        doc.text(`Material`, adjustedLeft + 50, adjustedTop + 70);
        doc.text(`Size (mm)`, adjustedLeft + 105, adjustedTop + 70);
        doc.text(`Thickness (µ)`, adjustedLeft + 129, adjustedTop + 70);
        doc.text(`Mat Req(kgs)`, adjustedLeft + 155, adjustedTop + 70);

 
   // Loop through combinedMaterials to render each material allocation line
order.combinedMaterials.forEach((material, index) => {
  if (material.process && material.material) {
      // Get process number from the processes array
      const processLabel = processes[index] || `Process ${index + 1}`; // Fallback if there are more materials than processes
      const combinedProcess = `${processLabel}: ${material.process}`; // Combine both labels

      doc.text(combinedProcess, adjustedLeft - 7, adjustedTop + 80 + index * 6);
      doc.text(String(material.material), adjustedLeft + 50, adjustedTop + 80 + index * 6);
      doc.text(String(material.width !== undefined ? material.width : 0), adjustedLeft + 105, adjustedTop + 80 + index * 6);
      doc.text(String(material.thickness !== undefined ? material.thickness : 0), adjustedLeft + 129, adjustedTop + 80 + index * 6);
      doc.text(String(material.matRequired !== undefined ? material.matRequired : 0), adjustedLeft + 155, adjustedTop + 80 + index * 6);
  }
});

        // Example section (Printing)
        doc.line(sideMargin, adjustedTop + 112, pageWidth - sideMargin, adjustedTop + 112);
        doc.text(`PRINTING`, adjustedLeft - 8, adjustedTop + 118);
        
        // Access cylinder properties
        const cylinder = order.cylinders || {}; // Safely access cylinders
        const cylinderSupplier = cylinder.supplier || '';
        const cylinderLength = cylinder.length || '';
        const cylinderLocation = cylinder.location || '';
        const cylinderCircumference = cylinder.circumference || '';

        const Time_Out = `Cylinder Location: ${cylinderLocation}`;
        doc.text(Time_Out, adjustedLeft + 130, adjustedTop + 146);
        doc.text(`Cylinder Supplier: ${cylinderSupplier}`, adjustedLeft - 7, adjustedTop + 128);
        doc.text(`Cylinder ID: ${cylinder.id || ''}`, adjustedLeft + 60, adjustedTop + 128);
        const Face_Length = `Face Length (mm): ${cylinderLength}`;
        doc.text(Face_Length, adjustedLeft + 115, adjustedTop + 128);
        doc.text(`Print type: ${order.printType || ''}`, adjustedLeft - 7, adjustedTop + 136);
        doc.text(`Print Direction: ${order.printDirection || ''}`, adjustedLeft + 60, adjustedTop + 136);
        const Circum = `Cylinder Circumference(mm): ${cylinderCircumference}`;
        doc.text(Circum, adjustedLeft + 56, adjustedTop + 146);

        const Ink_GSM = `Ink GSM: ${order.std}`;
        doc.text(Ink_GSM, adjustedLeft - 7, adjustedTop + 146);
        const InkType = `InkType: ${order.inkType}`;
        doc.text(InkType, adjustedLeft + 115, adjustedTop + 156);
        const No_of_Colors = `No of Colors: ${order.colorNumber}`;
        doc.text(No_of_Colors, adjustedLeft - 7, adjustedTop + 156);
        const Color_Names = `Color Names: ${order.colorNames}`;
        doc.text(Color_Names, adjustedLeft - 7, adjustedTop + 165);

        // Example section (Lamination)
        doc.line(sideMargin, adjustedTop + 170, pageWidth - sideMargin, adjustedTop + 170);
        doc.text(`LAMINATION`, adjustedLeft - 8, adjustedTop + 178);
        doc.text(`Lamination Type: ${order.LamType || ''}`, adjustedLeft - 8, adjustedTop + 185);
        doc.text(`Adhesive: ${order.nco || ''} x ${order.oh}`, adjustedLeft + 60, adjustedTop + 185);
        doc.text(`Total GSM: ${order.totalGsm || ''}`, adjustedLeft + 140, adjustedTop + 185);

        // Example section (Slitting)
        doc.line(sideMargin, adjustedTop + 190, pageWidth - sideMargin, adjustedTop + 190);
        doc.text(`SLITTING`, adjustedLeft - 8, adjustedTop + 196);
        doc.text(`Core Type: ${order.coreType || ''}`, adjustedLeft - 8, adjustedTop + 203);
        doc.text(`Coil Width(Ups): ${order.coilWidth || ''}`, adjustedLeft - 8, adjustedTop + 210);
        doc.text(`Coil OD(mm): ${order.coilod || ''}`, adjustedLeft + 60, adjustedTop + 210);
        doc.text(`Final Direction: ${order.fdOption || ''}`, adjustedLeft + 115, adjustedTop + 210);
        doc.text(`Repeat Length(Ups): ${order.repeatLength || ''}`, adjustedLeft - 8, adjustedTop + 218);
        doc.text(`Weight of Pouch/Piece: ${order.pouch || ''}`, adjustedLeft + 115, adjustedTop + 218);

        // Example section (Packing)
        doc.line(sideMargin, adjustedTop + 222, pageWidth - sideMargin, adjustedTop + 222);
        doc.text(`PACKING`, adjustedLeft - 8, adjustedTop + 228);
        doc.text(`Packing Type: ${order.packageType || ''}`, adjustedLeft - 8, adjustedTop + 235);

        // Example section (Gluing and Sleeves)
        doc.line(sideMargin, adjustedTop + 240, pageWidth - sideMargin, adjustedTop + 240);
        doc.text(`GLUING AND SLEEVES`, adjustedLeft - 8, adjustedTop + 244);
        doc.text(`Gluing: ${order.gluing || ''}`, adjustedLeft - 8, adjustedTop + 250);
        doc.text(`Roll Width: ${order.rollsWidth || ''}`, adjustedLeft + 60, adjustedTop + 250);
        doc.text(`Cutting Size: ${order.cutting || ''}`, adjustedLeft + 115, adjustedTop + 250);
        doc.text(`Prepared By: ${order.prepared || ''}`, adjustedLeft + 10, adjustedTop + 260);
        // doc.text(`Approved by: ${order.approved || ''}`, adjustedLeft + 115, adjustedTop + 260);
        doc.text(`Approved by Sales: ${order.approved || ''}`, adjustedLeft + 115, adjustedTop + 260);
        doc.text(`Approved by QC: ${  ''}`, adjustedLeft + 10, adjustedTop + 270);
        doc.text(`Approved by Operations: ${ ''}`, adjustedLeft + 115, adjustedTop + 270);
        // Example bottom design section
        doc.setFont('helvetica', 'bold');
        doc.text(`---- Job Ticket Report ----`, adjustedLeft + 60, adjustedTop + 280);

        // Save the PDF
        const pdfOutput = doc.output('bloburl');

        // Open the PDF in a new tab for preview
        window.open(pdfOutput);
    });
}


//   previewOrder(orderId: string) {
//     this.repeated.getRepeatOrderById(orderId).subscribe((order: any) => {
//     const doc = new jsPDF();

//     const pageWidth = doc.internal.pageSize.width;
//     const topMargin = 2;
//     const sideMargin = 10;
//     doc.setFont('helvetica');
//     const adjustedTop = topMargin + 8;
//     const adjustedLeft = sideMargin + 10;
//     doc.setFont('helvetica', 'bold');
//     const ticketText = 'LEXIPACK GHANA LIMITED';
//     const companyName = order.clientName || '';
//     const companyJob = `${order.jobName || ''} (${order.jobType || ''})`;
//     const textWidth = doc.getTextWidth(ticketText);
//     const textX = (pageWidth - textWidth) / 2;
//     doc.setFontSize(13);
//     doc.text(ticketText, textX, adjustedTop + 2);
//     doc.text(companyName, adjustedLeft, adjustedTop + 10);
//     doc.text(companyJob, adjustedLeft, adjustedTop + 16);
//     doc.line(sideMargin, adjustedTop + 18, pageWidth - sideMargin, adjustedTop + 18);
//     doc.setFontSize(11);
//     doc.setFont('helvetica', 'normal'); // Set font back to normal

//     // Render client and job details
//     const PoNo = `Po No: ${order.poNo}`;;
//     doc.text(PoNo, adjustedLeft - 8, adjustedTop + 23);
//     const originalDate = new Date(order.created);
//     const formattedDate = originalDate.toISOString().split('T')[0];

//     const formattedDateString = `Date: ${formattedDate}`;
//     doc.text(formattedDateString, adjustedLeft + 60, adjustedTop + 23);
//     // Get current time
//     const currentDate = new Date();
//     const currentTime = currentDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
//     const time = `Time: ${currentTime}`;  // Update the time field with current time
//     doc.text(time, adjustedLeft + 95, adjustedTop + 23);

//     // Set font style to bold
//     doc.setFont('helvetica', 'bold');
//     const Challan_No = `Ticket No: ${order.ticketno}`;
//     doc.text(Challan_No, adjustedLeft + 140, adjustedTop + 10);
//     // Assuming you have initialized doc, adjustedLeft, adjustedTop, and order.refNo appropriately

//     // Define the clientDetails string
//     const clientDetails = `Ref No: ${order.refNo}`;

//     // Set font style to bold
//     doc.setFont('helvetica', 'bold');

//     // Render the text with bold font
//     doc.text(clientDetails, adjustedLeft - 8, adjustedTop + 32);



//     const Serial = `FolderNo: ${order.jssfolderno}`;
//     doc.text(Serial, adjustedLeft + 60, adjustedTop + 32);
//     // Reset font style to normal (if needed for subsequent text)
//     doc.setFont('helvetica', 'normal');
//     const Barcode = `Barcode: ${order.barcode}`;
//     doc.text(Barcode, adjustedLeft + 140, adjustedTop + 32);
//     // const gstDetails = `JobName: ${order.jobName}`;
//     // doc.text(gstDetails, adjustedLeft - 8, adjustedTop + 36);
//     const Total_CMT = `JobType: ${order.jobType}`;
//     doc.text(Total_CMT, adjustedLeft - 8, adjustedTop + 40);
 
//     const ddDate = new Date(order.date1);
//     const formattedddDate = ddDate.toISOString().split('T')[0];

//     const formattedDDDateString = `Delivey Date: ${formattedddDate}`;
//     doc.text(formattedDDDateString, adjustedLeft + 140, adjustedTop + 40);
//     // const deliveyDate = `Delivey Date: ${order.date1}`;
//     // doc.text(deliveyDate, adjustedLeft + 140, adjustedTop + 40);
//     const status = `Status: ${order.status}`;
//     doc.text(status, adjustedLeft + 140, adjustedTop + 45);
//     // const driverDetails = `Pouch / Pcs : ${order.pouch}`;
//     // doc.text(driverDetails, adjustedLeft + 60, adjustedTop + 44);
//     const gradeQtyDetails = `Quantity:-`;
//     doc.text(gradeQtyDetails, adjustedLeft - 8, adjustedTop + 50);
//     const Qty = `Kgs: ${order.orderKgs}`;
//     doc.text(Qty, adjustedLeft + 20, adjustedTop + 50);
//     const TM_No = `PCs: ${order.pouch || order.orderPcs} `;
//     doc.text(TM_No, adjustedLeft + 20, adjustedTop + 55);
//     const Time_Out = `Cylinder Location: ${order.location}`;
//     doc.text(Time_Out, adjustedLeft + 96, adjustedTop + 50);
//     const Time_In = `Remarks: ${order.remark}`;
//     doc.text(Time_In, adjustedLeft + 96, adjustedTop + 55);

//     // Material Allocation section
//     doc.line(sideMargin, adjustedTop + 59, pageWidth - sideMargin, adjustedTop + 59);
//     doc.text(`RAW MATERIAL ALLOCATION`, adjustedLeft - 8, adjustedTop + 65);
//     doc.text(`Processes`, adjustedLeft - 5, adjustedTop + 70);
//     doc.text(`Material`, adjustedLeft + 50, adjustedTop + 70);
//     doc.text(`Size (mm)`, adjustedLeft + 105, adjustedTop + 70);
//     doc.text(`Thickness (µ)`, adjustedLeft + 129, adjustedTop + 70);
//     doc.text(`Mat Req(kgs)`, adjustedLeft + 155, adjustedTop + 70);
// // Loop through combinedMaterials to render each material allocation line
// order.combinedMaterials.forEach((material, index) => {
//   if (material.process && material.material) {
//     const processLine = String(material.process); // Ensure it's a string
//     const materialLine = String(material.material); // Ensure it's a string
//     const sizeLine = String(material.width !== undefined ? material.width : 0); // Convert to string, use 0 if undefined
//     const thicknessLine = String(material.thickness !== undefined ? material.thickness : 0); // Convert to string, use 0 if undefined
//     const matReqLine = String(material.matRequired !== undefined ? material.matRequired : 0); // Convert to string, use 0 if undefined

//     doc.text(processLine, adjustedLeft - 7, adjustedTop + 80 + index * 6);
//     doc.text(materialLine, adjustedLeft + 50, adjustedTop + 80 + index * 6);
//     doc.text(sizeLine, adjustedLeft + 105, adjustedTop + 80 + index * 6);
//     doc.text(thicknessLine, adjustedLeft + 129, adjustedTop + 80 + index * 6);
//     doc.text(matReqLine, adjustedLeft + 155, adjustedTop + 80 + index * 6);
//   }
// });




//     // Additional sections (Printing, Lamination, Slitting, Packing, Gluing and Sleeves, Bottom Design)
//     // These sections should be filled according to your specific needs

//     // Example section (Printing)
//     doc.line(sideMargin, adjustedTop + 112, pageWidth - sideMargin, adjustedTop + 112);
//     doc.text(`PRINTING`, adjustedLeft - 8, adjustedTop + 118);
//     doc.text(`Cylinder Supplier: ${order.supplier || ''}`, adjustedLeft - 7, adjustedTop + 128);
//     doc.text(`Cylinder ID: ${order.id || ''}`, adjustedLeft + 60, adjustedTop + 128);
//     const Face_Length = `Face Length (mm): ${order.length || ''}`;
//     doc.text(Face_Length, adjustedLeft + 115, adjustedTop + 128);
//     doc.text(`Print type: ${order.printType || ''}`, adjustedLeft - 7, adjustedTop + 136);
//     doc.text(`Print Direction: ${order.printDirection || ''}`, adjustedLeft + 60, adjustedTop + 136);
//     const Circum = `Cylinder Circumference(mm): ${order.circumference || ''}`;
//     doc.text(Circum, adjustedLeft + 115, adjustedTop + 146);

//     // const CONS = `CONS:-`;
//     // doc.text(CONS, adjustedLeft - 7, adjustedTop + 146);
//     const Ink_GSM = `Ink GSM: ${order.std}`;
//     doc.text(Ink_GSM, adjustedLeft - 7, adjustedTop + 146);
//     // const Liquid_Inks = `Liquid Inks: ${order.liquid}`;
//     // doc.text(Liquid_Inks, adjustedLeft + 60, adjustedTop + 146);
//     const InkType = `InkType: ${order.inkType}`;
//     doc.text(InkType, adjustedLeft + 115, adjustedTop + 156);
//     // const No_of_Colors = `No of Colors: ${order.color}`;

//     const No_of_Colors = `No of Colors: ${order.colorNumber}`;
//     doc.text(No_of_Colors, adjustedLeft - 7, adjustedTop + 156);
//     // const ActualPrint ='Actual printing material size:-';
//     // doc.text(ActualPrint, adjustedLeft-7 ,adjustedTop + 165);
//     const Color_Names = `Color Names:- ${order.colorNames}`;
//     doc.text(Color_Names, adjustedLeft - 7, adjustedTop + 165);


//     // Example section (Lamination)
//     doc.line(sideMargin, adjustedTop + 170, pageWidth - sideMargin, adjustedTop + 170);
//     doc.text(`LAMINATION`, adjustedLeft - 8, adjustedTop + 178);
//     doc.text(`Lamination Type: ${order.
//       LamType || ''}`, adjustedLeft - 8, adjustedTop + 185);
//     doc.text(`Adhesive: ${order.adhesive || ''}`, adjustedLeft + 60, adjustedTop + 185);


//     // Example section (Slitting)
//     doc.line(sideMargin, adjustedTop + 190, pageWidth - sideMargin, adjustedTop + 190);
//     doc.text(`SLITTING`, adjustedLeft - 8, adjustedTop + 196);
//     doc.text(`Core Type: ${order.coreType || ''}`, adjustedLeft - 8, adjustedTop + 203);
//     doc.text(`Coil Width(Ups): ${order.coilWidth || ''}`, adjustedLeft - 8, adjustedTop + 210);
//     doc.text(`Coil OD(mm): ${order.coilod || ''}`, adjustedLeft + 60, adjustedTop + 210);
//     doc.text(`Final Direction: ${order.fdOption || ''}`, adjustedLeft + 115, adjustedTop + 210);
//     doc.text(`Repeat Length(Ups): ${order.repeatLength || ''}`, adjustedLeft - 8, adjustedTop + 218);
//     doc.text(`Weight of Pouch/Piece: ${order.pouch || ''}`, adjustedLeft + 115, adjustedTop + 218);

//     // Example section (Packing)
//     doc.line(sideMargin, adjustedTop + 222, pageWidth - sideMargin, adjustedTop + 222);
//     doc.text(`PACKING`, adjustedLeft - 8, adjustedTop + 228);
//     doc.text(`Packing Type: ${order.packageType || ''}`, adjustedLeft - 8, adjustedTop + 235);

//     // Example section (Gluing and Sleeves)
//     doc.line(sideMargin, adjustedTop + 240, pageWidth - sideMargin, adjustedTop + 240);
//     doc.text(`GLUING AND SLEEVES`, adjustedLeft - 8, adjustedTop + 244);
//     doc.text(`Gluing: ${order.gluing || ''}`, adjustedLeft - 8, adjustedTop + 250);
//     doc.text(`Roll Width: ${order.rollsWidth || ''}`, adjustedLeft + 60, adjustedTop + 250);
//     doc.text(`Cutting Size: ${order.cutting || ''}`, adjustedLeft + 115, adjustedTop + 250);
//     doc.text(`Prepared By: ${order.prepared || ''}`, adjustedLeft + 10, adjustedTop + 260);
//     doc.text(`Approved by: ${order.approved || ''}`, adjustedLeft + 115, adjustedTop + 260);

//     // Example bottom design section
//     doc.setFont('helvetica', 'bold');
//     doc.text(`---- Job Ticket Report ----`, adjustedLeft + 60, adjustedTop + 280);

//     // Save the PDF
//     const pdfOutput = doc.output('bloburl');

//     // Open the PDF in a new tab for preview
//     window.open(pdfOutput);
//     });
// }

}
